import { render, staticRenderFns } from "./Vaanampaadi.vue?vue&type=template&id=40f88cb2&scoped=true"
import script from "./Vaanampaadi.vue?vue&type=script&lang=js"
export * from "./Vaanampaadi.vue?vue&type=script&lang=js"
import style0 from "./Vaanampaadi.vue?vue&type=style&index=0&id=40f88cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f88cb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFlex,VImg,VLayout,VRow})
